// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XE_K","toggleWrap":"styles_toggleWrap__Tej7Z","content":"styles_content__eslfC","selectAreaCode":"styles_selectAreaCode__QioQF"};